/** All application path strings. Never inline a route literal anywhere else. */
export const ROUTES = {
  // Auth
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',

  // Platform
  OVERVIEW: '/overview',
  ASSETS: '/assets',
  ASSET_DETAIL: '/assets/:id',
  GATEWAYS: '/gateways',
  GATEWAY_DETAIL: '/gateways/:id',
  TAGS: '/tags',
  TAG_HISTORY: '/tags/:id/history',
  ALARMS: '/alarms',
  DASHBOARDS: '/dashboards',
  DASHBOARD_VIEW: '/dashboards/:id',
  DASHBOARD_BUILD: '/dashboards/:id/edit',
  DASHBOARD_NEW: '/dashboards/new',
  /** Dashboard/Screen Builder (v2 schema). Lazy-loaded, code-split module. */
  DASHBOARD_BUILDER: '/dashboards/:id/builder',
  REPORTS: '/reports',
  REPORT_NEW: '/reports/new',
  REPORT_EDIT: '/reports/:id/edit',

  // Partner portal
  PARTNER: '/partner',
  CUSTOMERS: '/partner/customers',
  CUSTOMER_DETAIL: '/partner/customers/:id',

  // Admin authoring (Dashboard Builder Stage 2.5)
  CONNECTORS: '/connections',
  SAVED_QUERIES: '/queries',
  SAVED_QUERY_NEW: '/queries/new',
  SAVED_QUERY_EDIT: '/queries/:id/edit',

  // Admin
  SETTINGS: '/settings',
} as const

export type AppRoute = (typeof ROUTES)[keyof typeof ROUTES]
